import React from "react";
import { Helmet } from "react-helmet";
import DefaultHelmetMeta from "../../../../components/DefaultHelmetMeta";

export const PostDetailedHtmlHead = props => {
  if (!props.post) {
    return (
      <Helmet>
        <title>Casemasters - Cases</title>
        <DefaultHelmetMeta />
      </Helmet>
    );
  }

  return (
    <Helmet>
      <title>{props.post.title}</title>
      <meta
        name="description"
        content="View dental cases on casemasters, Largest online dental platform for dentists to showcase and discover great dental work."
      />
      <meta property="og:title" content={props.post.title} />
      <meta property="og:description" content={props.post.description} />
      <meta property="og:image" content={props.post.images[0].url} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:url" content={`https://www.casemasters.com/posts/${props.post._id}`} />
    </Helmet>
  );
};

export default PostDetailedHtmlHead;



// WEBPACK FOOTER //
// ./src/scenes/PostDetailed/components/PostDetailedHtmlHead/index.js